import { TEDMixedType, MixedValueType } from '../../Types/GraphQLTypes';
import Logger from '../../Utils/Logger';

export const getMixedValue = (mixedValue: TEDMixedType): MixedValueType => {
  switch (mixedValue.__typename) {
    case 'TEDMixedString': {
      return mixedValue.asString;
    }
    case 'TEDMixedInt': {
      return mixedValue.asInt;
    }
    case 'TEDMixedBoolean': {
      return mixedValue.asBoolean;
    }
    case 'TEDMixedFloat': {
      return mixedValue.asFloat;
    }
    case 'TEDMixedCurrency': {
      return mixedValue.asCurrency;
    }
    case 'TEDMixedDate': {
      return mixedValue.asDate;
    }
    case 'TEDMixedTime': {
      return mixedValue.asTime;
    }
    case 'TEDMixedDateTime': {
      return mixedValue.asDateTime;
    }
    case 'TEDMixedStringArray': {
      return mixedValue.asStringArray;
    }
    case 'TEDMixedIntArray': {
      return mixedValue.asIntArray;
    }
    case 'TEDMixedBooleanArray': {
      return mixedValue.asBooleanArray;
    }
    case 'TEDMixedFloatArray': {
      return mixedValue.asFloatArray;
    }
    case 'TEDMixedCurrencyArray': {
      return mixedValue.asCurrencyArray;
    }
    case 'TEDMixedDateArray': {
      return mixedValue.asDateArray;
    }
    case 'TEDMixedTimeArray': {
      return mixedValue.asTimeArray;
    }
    case 'TEDMixedDateTimeArray': {
      return mixedValue.asDateTimeArray;
    }
    default: {
      Logger.error(
        `No value on mixed value: ${JSON.stringify(mixedValue, null, 2)}`
      );
      return 'No Value';
    }
  }
};
